import { takeLatest, call, put } from 'redux-saga/effects';
import * as adminInfoActions from 'redux/ducks/adminInfo/adminInfoDucks';
import employeeApi from 'api/employee/employeeApi';
import approvalApi from 'api/approval/approvalApi';
import * as alertActions from 'redux/ducks/common/alertDucks';

export function* getAdminInfo() {
  try {
    const response = yield call(employeeApi.getAdminInfo);
    yield put(adminInfoActions.getAdminInfoSuccess(response));
  } catch (error) {
    yield put(
      alertActions.open({
        message: [error ? error.errorCode : 'CO401'],
      }),
    );
    yield put(adminInfoActions.getAdminInfoFail(error));
  }
}
export function* updatePortalConfig({ payload }) {
  try {
    const response = yield call(employeeApi.updatePortalConfig, payload);
    yield put(adminInfoActions.updatePortalConfigSuccess(response));
  } catch (error) {
    // error  alert 노출!
    yield put(alertActions.open({ message: ['CO403'] }));
    yield put(adminInfoActions.updatePortalConfigFail(error));
  }
}

export function* updateFinishPortalConfig({ payload }) {
  try {
    const response = yield call(employeeApi.updatePortalConfig, payload);
    yield put(adminInfoActions.updateFinishPortalConfigSuccess(response));
  } catch (error) {
    // error  alert 노출!
    yield put(adminInfoActions.updateFinishPortalConfigFail(error));
  }
}

export function* createApprovalComp({ payload }) {
  try {
    const response = yield call(approvalApi.approvalCompCreate, payload);
    yield put(adminInfoActions.createApprovalCompSuccess(response));
  } catch (error) {
    if (error.errorCode !== 'AP199') {
      yield put(alertActions.open({ message: [error.errorCode] }));
    }
  }
}

export default function* AdminInfoSaga() {
  yield takeLatest(adminInfoActions.getAdminInfo, getAdminInfo);
  yield takeLatest(adminInfoActions.updatePortalConfig, updatePortalConfig);
  yield takeLatest(adminInfoActions.updateFinishPortalConfig, updateFinishPortalConfig);
  yield takeLatest(adminInfoActions.createApprovalComp, createApprovalComp);
}
